import AuthRefresh from '@/services/auth/auth.refresh'
export default function check() {

  setInterval(() =>{

    let user = localStorage.getItem('user');
    if (user) {
      let user = JSON.parse(atob(localStorage.getItem('user')))
      let timestamp = new Date().getTime();
      let timestampExpire = user.expire_at * 1000
      if (timestamp > timestampExpire) {
        AuthRefresh.getNewAccessToken(user.refreshToken)
      } 
    }
  },2000)
   // 900000 - 15 minuti
   // 120000 - 2 minuti
   // 2000 - 2 secondi

}
